<div class="container">
  <mat-card appearance="outlined">
      <mat-card-title class="btn btn-rose">Add New Datacenter</mat-card-title>
      <mat-card-subtitle></mat-card-subtitle>
      <mat-card-content>
          <form [formGroup]="addWarehouseForm" (ngSubmit)="addWarehouseForm.valid && saveHouse()" novalidate>
              <div class="row">
                  <div class="col-md-6">
                      <mat-form-field appearance="fill" color="accent">
                        <mat-label>Datacenter Name</mat-label>
                        <input matInput type="text" placeholder="Enter Datacenter Name" name="warehouseName" id="warehouseName"
                               formControlName="warehouseName" autocomplete="off" maxlength="50">
                        <mat-error *ngIf="addWarehouseForm.get('warehouseName').hasError('required')">
                            Datacenter Name is required.
                        </mat-error>
                        <mat-error *ngIf="addWarehouseForm.get('warehouseName').hasError('maxlength')">
                            Datacenter Name cannot be more than 50 characters.
                          </mat-error>
                           <mat-error *ngIf="addWarehouseForm.get('warehouseName').hasError('maxlength')">
                            Datacenter Name cannot be more than 50 characters.
                      </mat-error>
                      </mat-form-field>
                  </div>
                  <div class="col-md-6">
                    <mat-form-field appearance="fill" color="accent">
                        <mat-label>Description</mat-label>
                        <input matInput type="text" placeholder="Enter Description" name="description" id="description"
                               formControlName="description" autocomplete="off" maxlength="100" >
                        <mat-error *ngIf="addWarehouseForm.get('description').hasError('required')">
                          Description is required.
                        </mat-error>
                        <mat-error *ngIf="addWarehouseForm.get('description').hasError('maxlength')">
                            Description cannot be more than 100 characters.
                          </mat-error>
                            <mat-error *ngIf="addWarehouseForm.get('description').hasError('maxlength')">
                            Description cannot be more than 100 characters.
                      </mat-error>
                      </mat-form-field>
                  </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                     <!-- State Field -->
                     <mat-form-field *ngIf="states.length > 0">
                        <mat-label>State</mat-label>
                        <mat-select [placeholder]="'States'"
                            (selectionChange)="onSelectionchange($event)"
                            formControlName="stateId">
                            <mat-form-field>
                                <input matInput type="text" (keyup)="search($event.target.value)" placeholder="search state">
                            </mat-form-field>
                            <mat-divider></mat-divider>
                            <mat-option *ngFor="let state of selectedStates; let i = index;" [value]="state.stateId">
                                {{state.stateName}}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="addWarehouseForm.get('stateId').hasError('required')">
                            State is required.
                          </mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6">
                    <mat-form-field appearance="fill" color="accent">
                        <mat-label>City</mat-label>
                        <mat-select formControlName="cityId">
                          <mat-option [value]="null">Select a city</mat-option>
                          <mat-option *ngFor="let city of cities" [value]="city.cityId">{{ city.cityName }}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="addWarehouseForm.get('cityId').hasError('required')">
                          City is required.
                        </mat-error>
                      </mat-form-field>
                </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                  <mat-form-field>
                      <input matInput type="text" placeholder="Address" name="warehouseName" 
                      id="address" formControlName="address" maxlength="250" />
                       <mat-error *ngIf="addWarehouseForm.get('address').hasError('required')">
                          Address is required.
                        </mat-error>
                        <mat-error *ngIf="addWarehouseForm.get('address').hasError('maxlength')">
                            Address cannot be more than 250 characters.
                      </mat-error>
                  </mat-form-field>
              </div>
              <div class="col-md-6">
                  <mat-form-field>
                    <mat-select [placeholder]="'Manager'" formControlName="warehouseManager" [disabled]="userOptionsDto == null">
                        <mat-option [value]="null">Select an option</mat-option>
                        <mat-option *ngFor="let user of userOptionsDto; let i = index;"
                        [value]="user.userId"
                        [matTooltip]="'First Name: ' + user.firstName + '\nLast Name: ' + user.lastName + '\nEmail: ' + user.email"
                        >
                        {{user.employeeId}} | {{user.firstName}} {{user.lastName}}
                    </mat-option>
                    </mat-select>
                </mat-form-field>
              </div>
          </div>

          </form>
      </mat-card-content>
      <mat-card-footer>
          <div class="row action-btn justify-content-center">
              <div class="col-md-6">
                  <button md-raised-button type="button" class="btn btn-round btn-block btn-rose"
                      (click)="close()">Close</button>
              </div>
              <div class="col-md-6">
                  <button md-raised-button type="button" class="btn btn-round btn-block btn-rose"
                      (click)="saveHouse()" [disabled]="!addWarehouseForm.valid">Save</button>
              </div>
          </div>
      </mat-card-footer>
  </mat-card>
</div>

 